import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography
} from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { Fragment } from 'react'

const MediaControls = ({
  open,
  handleClose,
  audioOptions,
  videoOptions,
  webRTCAdaptor,
  streamUUID,
  setState
}) => {
  const [audioSource, setAudioSource] = useState(null)
  const [videoSource, setVideoSource] = useState(null)
  useEffect(() => {
    if (open) {
      const activeAudio = audioOptions.find(x => x.isActive)
      const activeVideo = videoOptions.find(x => x.isActive)
      //   console.log(activeAudio, activeVideo)
      if (activeAudio) setAudioSource(activeAudio.deviceId)
      if (activeVideo) setVideoSource(activeVideo.deviceId)
    }
  }, [open])

  const updateSources = () => {
    // update audio source
    webRTCAdaptor.switchAudioInputSource(streamUUID, audioSource)

    // update video source
    if (videoSource === 'screen') {
      webRTCAdaptor.switchDesktopCapture(streamUUID)
    } else if (videoSource === 'screen+camera') {
      webRTCAdaptor.switchDesktopCaptureWithCamera(streamUUID, videoSource)
    } else {
      webRTCAdaptor.switchVideoCameraCapture(streamUUID, videoSource)
    }

    const newAudio = audioOptions.map(x => {
      x.isActive = x.deviceId === audioSource
      return x
    })

    const newVideo = videoOptions.map(x => {
      x.isActive = x.deviceId === videoSource
      return x
    })

    // console.log(newAudio, newVideo)

    setState({
      audioOptions: newAudio,
      videoOptions: newVideo
    })

    handleClose()
  }

  let isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  )

  return (
    <Dialog open={open}>
      <DialogContent>
        <Typography variant="h5">Change Media Sources</Typography>
      </DialogContent>
      <DialogContent>
        <Typography variant="h6">Change Video Source</Typography>
        <RadioGroup
          name="video source"
          value={videoSource}
          onChange={e => setVideoSource(e.target.value)}
        >
          {videoOptions.map(x => {
            return (
              <FormControlLabel
                value={x.deviceId}
                control={<Radio />}
                label={x.label}
              />
            )
          })}
          {!isMobile && (
            <Fragment>
              <FormControlLabel
                value={'screen'}
                control={<Radio />}
                label={'Screen'}
              />
              <FormControlLabel
                value={'screen+camera'}
                control={<Radio />}
                label={'Screen With Camera'}
              />
            </Fragment>
          )}
        </RadioGroup>
        <br />
        <Typography variant="h6">Change Audio Source</Typography>
        <RadioGroup
          name="audio source"
          value={audioSource}
          onChange={e => setAudioSource(e.target.value)}
        >
          {audioOptions.map(x => {
            return (
              <FormControlLabel
                value={x.deviceId}
                control={<Radio />}
                label={x.label}
              />
            )
          })}
        </RadioGroup>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="primary" onClick={updateSources}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default MediaControls



// WEBPACK FOOTER //
// ./src/components/Streamer/mediaControls.js